import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_latest_videos_carousel_full = _resolveComponent("home-latest-videos-carousel-full")!
  const _component_home_latest_videos_carousel_card = _resolveComponent("home-latest-videos-carousel-card")!

  return (_ctx.store.state.base.responsive.isSM)
    ? (_openBlock(), _createBlock(_component_home_latest_videos_carousel_full, {
        key: 0,
        videos: _ctx.videos
      }, null, 8, ["videos"]))
    : (_openBlock(), _createBlock(_component_home_latest_videos_carousel_card, {
        key: 1,
        videos: _ctx.videos
      }, null, 8, ["videos"]))
}